export const reportViewEnum = {
  ASSET: 'ASSET',
  ASSET_POSITION: 'ASSET_POSITION',
} as const

export type ReportViewEnum = (typeof reportViewEnum)[keyof typeof reportViewEnum]

export type ReportView = ReportViewEnum